export enum TransferAccountSelectViewState {
  SourceSelect = "SourceAccount",
  DestinationSelect = "DestinationSelect",
}
